import React from 'react';
import PropTypes from 'prop-types';
import getLocaleMessages from '../../utils/localesMessages';
import { Divider, Switch, Badge } from '@paypalcorp/pp-react'; // For some reason if we import it from pp-react-switch, we don't get the inline and secondary label feature
import { shouldShowBadge } from '../../utilsV3/badgeUtils';

const { toggle = {} } = getLocaleMessages('buttonsV3/switches');

export const renderSwitchComponent = (props) => {
  if (props.reversed) {
    return <SwitchPanel value={props.isChecked ? 'no' : 'yes'} {...props} />;
  }
  return <SwitchPanel value={props.isChecked ? 'yes' : 'no'} {...props} />;
};

renderSwitchComponent.propTypes = {
  isChecked: PropTypes.bool,
  reversed: PropTypes.bool,
};

// onToggle and isChecked props should be passed down by parent component to use switch value
const SwitchPanel = (props) => {
  const { title, subTitle, isChecked, noDivider, input, value, id, showBadge } =
    props;
  const badgeContent = shouldShowBadge(showBadge);

  return (
    <>
      {noDivider ? null : <Divider className="switch-divider" />}
      <Switch
        inline
        id={id}
        className="switch-panel badge-component"
        label={title}
        secondaryLabel={subTitle}
        onLabel={toggle.yes}
        offLabel={toggle.no}
        checked={isChecked}
        onChange={() => input.onChange(value === 'yes' ? 'no' : 'yes')}
        value={value}
        labelIcon={
          badgeContent && (
            <Badge aria-hidden={true} type="feature" className="badge-feature">
              {badgeContent}
            </Badge>
          )
        }
      />
    </>
  );
};

SwitchPanel.propTypes = {
  input: PropTypes.object,
  isChecked: PropTypes.bool,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  value: PropTypes.string,
};

export default SwitchPanel;
